/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as SurveyResultsRouteImport } from './routes/survey-results'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SettingsTeamRouteImport } from './routes/settings-team'
import { Route as SettingsStripeRouteImport } from './routes/settings-stripe'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SequencesRouteImport } from './routes/sequences'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CancellationsRouteImport } from './routes/cancellations'
import { Route as AbTestsRouteImport } from './routes/ab-tests'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SequencesIndexRouteImport } from './routes/sequences.index'
import { Route as CancellationsIndexRouteImport } from './routes/cancellations.index'
import { Route as SequencesNewRouteImport } from './routes/sequences.new'
import { Route as SequencesIdRouteImport } from './routes/sequences.$id'
import { Route as CancellationsIdRouteImport } from './routes/cancellations.$id'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const SurveyResultsRoute = SurveyResultsRouteImport.update({
  id: '/survey-results',
  path: '/survey-results',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsTeamRoute = SettingsTeamRouteImport.update({
  id: '/settings-team',
  path: '/settings-team',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsStripeRoute = SettingsStripeRouteImport.update({
  id: '/settings-stripe',
  path: '/settings-stripe',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SequencesRoute = SequencesRouteImport.update({
  id: '/sequences',
  path: '/sequences',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CancellationsRoute = CancellationsRouteImport.update({
  id: '/cancellations',
  path: '/cancellations',
  getParentRoute: () => rootRouteImport,
} as any)
const AbTestsRoute = AbTestsRouteImport.update({
  id: '/ab-tests',
  path: '/ab-tests',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SequencesIndexRoute = SequencesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SequencesRoute,
} as any)
const CancellationsIndexRoute = CancellationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CancellationsRoute,
} as any)
const SequencesNewRoute = SequencesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => SequencesRoute,
} as any)
const SequencesIdRoute = SequencesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SequencesRoute,
} as any)
const CancellationsIdRoute = CancellationsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CancellationsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ab-tests': typeof AbTestsRoute
  '/cancellations': typeof CancellationsRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sequences': typeof SequencesRouteWithChildren
  '/settings': typeof SettingsRoute
  '/settings-stripe': typeof SettingsStripeRoute
  '/settings-team': typeof SettingsTeamRoute
  '/signup': typeof SignupRoute
  '/survey-results': typeof SurveyResultsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/cancellations/$id': typeof CancellationsIdRoute
  '/sequences/$id': typeof SequencesIdRoute
  '/sequences/new': typeof SequencesNewRoute
  '/cancellations/': typeof CancellationsIndexRoute
  '/sequences/': typeof SequencesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ab-tests': typeof AbTestsRoute
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/settings-stripe': typeof SettingsStripeRoute
  '/settings-team': typeof SettingsTeamRoute
  '/signup': typeof SignupRoute
  '/survey-results': typeof SurveyResultsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/cancellations/$id': typeof CancellationsIdRoute
  '/sequences/$id': typeof SequencesIdRoute
  '/sequences/new': typeof SequencesNewRoute
  '/cancellations': typeof CancellationsIndexRoute
  '/sequences': typeof SequencesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ab-tests': typeof AbTestsRoute
  '/cancellations': typeof CancellationsRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sequences': typeof SequencesRouteWithChildren
  '/settings': typeof SettingsRoute
  '/settings-stripe': typeof SettingsStripeRoute
  '/settings-team': typeof SettingsTeamRoute
  '/signup': typeof SignupRoute
  '/survey-results': typeof SurveyResultsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/cancellations/$id': typeof CancellationsIdRoute
  '/sequences/$id': typeof SequencesIdRoute
  '/sequences/new': typeof SequencesNewRoute
  '/cancellations/': typeof CancellationsIndexRoute
  '/sequences/': typeof SequencesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ab-tests'
    | '/cancellations'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/sequences'
    | '/settings'
    | '/settings-stripe'
    | '/settings-team'
    | '/signup'
    | '/survey-results'
    | '/verify-email'
    | '/cancellations/$id'
    | '/sequences/$id'
    | '/sequences/new'
    | '/cancellations/'
    | '/sequences/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ab-tests'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/settings'
    | '/settings-stripe'
    | '/settings-team'
    | '/signup'
    | '/survey-results'
    | '/verify-email'
    | '/cancellations/$id'
    | '/sequences/$id'
    | '/sequences/new'
    | '/cancellations'
    | '/sequences'
  id:
    | '__root__'
    | '/'
    | '/ab-tests'
    | '/cancellations'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/sequences'
    | '/settings'
    | '/settings-stripe'
    | '/settings-team'
    | '/signup'
    | '/survey-results'
    | '/verify-email'
    | '/cancellations/$id'
    | '/sequences/$id'
    | '/sequences/new'
    | '/cancellations/'
    | '/sequences/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AbTestsRoute: typeof AbTestsRoute
  CancellationsRoute: typeof CancellationsRouteWithChildren
  DashboardRoute: typeof DashboardRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SequencesRoute: typeof SequencesRouteWithChildren
  SettingsRoute: typeof SettingsRoute
  SettingsStripeRoute: typeof SettingsStripeRoute
  SettingsTeamRoute: typeof SettingsTeamRoute
  SignupRoute: typeof SignupRoute
  SurveyResultsRoute: typeof SurveyResultsRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/survey-results': {
      id: '/survey-results'
      path: '/survey-results'
      fullPath: '/survey-results'
      preLoaderRoute: typeof SurveyResultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings-team': {
      id: '/settings-team'
      path: '/settings-team'
      fullPath: '/settings-team'
      preLoaderRoute: typeof SettingsTeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings-stripe': {
      id: '/settings-stripe'
      path: '/settings-stripe'
      fullPath: '/settings-stripe'
      preLoaderRoute: typeof SettingsStripeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sequences': {
      id: '/sequences'
      path: '/sequences'
      fullPath: '/sequences'
      preLoaderRoute: typeof SequencesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cancellations': {
      id: '/cancellations'
      path: '/cancellations'
      fullPath: '/cancellations'
      preLoaderRoute: typeof CancellationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ab-tests': {
      id: '/ab-tests'
      path: '/ab-tests'
      fullPath: '/ab-tests'
      preLoaderRoute: typeof AbTestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sequences/': {
      id: '/sequences/'
      path: '/'
      fullPath: '/sequences/'
      preLoaderRoute: typeof SequencesIndexRouteImport
      parentRoute: typeof SequencesRoute
    }
    '/cancellations/': {
      id: '/cancellations/'
      path: '/'
      fullPath: '/cancellations/'
      preLoaderRoute: typeof CancellationsIndexRouteImport
      parentRoute: typeof CancellationsRoute
    }
    '/sequences/new': {
      id: '/sequences/new'
      path: '/new'
      fullPath: '/sequences/new'
      preLoaderRoute: typeof SequencesNewRouteImport
      parentRoute: typeof SequencesRoute
    }
    '/sequences/$id': {
      id: '/sequences/$id'
      path: '/$id'
      fullPath: '/sequences/$id'
      preLoaderRoute: typeof SequencesIdRouteImport
      parentRoute: typeof SequencesRoute
    }
    '/cancellations/$id': {
      id: '/cancellations/$id'
      path: '/$id'
      fullPath: '/cancellations/$id'
      preLoaderRoute: typeof CancellationsIdRouteImport
      parentRoute: typeof CancellationsRoute
    }
  }
}

interface CancellationsRouteChildren {
  CancellationsIdRoute: typeof CancellationsIdRoute
  CancellationsIndexRoute: typeof CancellationsIndexRoute
}

const CancellationsRouteChildren: CancellationsRouteChildren = {
  CancellationsIdRoute: CancellationsIdRoute,
  CancellationsIndexRoute: CancellationsIndexRoute,
}

const CancellationsRouteWithChildren = CancellationsRoute._addFileChildren(
  CancellationsRouteChildren,
)

interface SequencesRouteChildren {
  SequencesIdRoute: typeof SequencesIdRoute
  SequencesNewRoute: typeof SequencesNewRoute
  SequencesIndexRoute: typeof SequencesIndexRoute
}

const SequencesRouteChildren: SequencesRouteChildren = {
  SequencesIdRoute: SequencesIdRoute,
  SequencesNewRoute: SequencesNewRoute,
  SequencesIndexRoute: SequencesIndexRoute,
}

const SequencesRouteWithChildren = SequencesRoute._addFileChildren(
  SequencesRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AbTestsRoute: AbTestsRoute,
  CancellationsRoute: CancellationsRouteWithChildren,
  DashboardRoute: DashboardRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SequencesRoute: SequencesRouteWithChildren,
  SettingsRoute: SettingsRoute,
  SettingsStripeRoute: SettingsStripeRoute,
  SettingsTeamRoute: SettingsTeamRoute,
  SignupRoute: SignupRoute,
  SurveyResultsRoute: SurveyResultsRoute,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
